export default import.meta.ROLLUP_FILE_URL_y3WuTrdTs_Si7uYpRddj9w;